// extracted by mini-css-extract-plugin
export default {"container":"ShipmentInvoiceFormOverview_container__CFRRS","tag":"ShipmentInvoiceFormOverview_tag__0kF+X","price":"ShipmentInvoiceFormOverview_price__CqOU8"};